export enum FormattingDto {
    None = 0,
    Bold = 1,
    Italic = 2,
    Link = 3,
    Quote = 4,
    Uppercase = 5,
    Lowercase = 6,
    /** Raw-HTML formatting range; not rendered by this client. */
    Html = 7,
}
